import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Catalog from "./pages/Catalog";
import Login from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ProductList from "./admin/pages/Products/ProductList";
import ProductDetails from "./admin/pages/Products/ProductDetails";
import ProductForm from "./admin/pages/Products/ProductForm";
import CategoryList from "./admin/pages/Categories/CategoryList";
import AdminLayout from "./admin/components/AdminLayout";
import ProtectedRoute from "./admin/components/ProtectedAdminRoute";
import ProductUpdate from "./admin/pages/Products/ProductUpdate";
import CategoryProducts from "./pages/CategoryProducts";
import OrderConfirmation from "./pages/OrderConfirmation";
import Orders from "./admin/pages/Orders/Orders";
import ContactSubmissions from "./admin/pages/ContactSubmissions/ContactSubmissions";
import AdminSignup from "./admin/pages/CreateAdmin/CreateAdmin";
import AdminList from "./admin/pages/CreateAdmin/AdminList";
import ManageSubscriptions from "./admin/pages/ContactSubmissions/ManageSubscriptions";
import BlogList from "./admin/pages/Blogs/BlogList";
import BlogForm from "./admin/pages/Blogs/BlogForm";
import BlogView from "./admin/pages/Blogs/BlogView";
import ProductOrderManager from "./admin/pages/Products/ProductOrderManagement";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* General shop page (no category filter initially) */}
      <Route path="/shop" element={<Shop />} />

      {/* Shop page with a specific category filter applied */}
      <Route path="/shop/category/:categoryId" element={<Shop />} />
      <Route path="/shop/category/:categoryId/subcategory/:subcategoryId" element={<Shop />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/confirmorder" element={<OrderConfirmation />} />
      <Route path="/about" element={<About />} />
      <Route path="/catalog" element={<Catalog />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />

      {/* Protected Admin Routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly={true}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="products" element={<ProductList />} />
        <Route path="categories" element={<CategoryList />} />
        <Route path="/admin/products/:id/view" element={<ProductDetails />} />
        <Route path="/admin/products/new" element={<ProductForm />} />
        <Route path="/admin/products/:id/edit" element={<ProductUpdate />} />
        <Route path="/admin/products/order" element={<ProductOrderManager/>}/>
        <Route path="/admin/orders" element={<Orders />} />
        <Route path="/admin/contactsubmissions" element={<ContactSubmissions />} />
        <Route path="/admin/managesubscriptions" element={<ManageSubscriptions />} />
        <Route path="/admin/createadmin" element={<AdminSignup />} />
        <Route path="/admin/adminlist" element={<AdminList />} />
        <Route path="/admin/blogs" element={<BlogList />} />
        <Route path="/admin/blogs/new" element={<BlogForm />} />
        <Route path="/admin/blogs/:id" element={<BlogView />} />
        <Route path="/admin/blogs/:id/edit" element={<BlogForm />} />

      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
